import {
  BudgetValidationActions,
  BudgetValidationArbitrationRow,
  BudgetValidationCards,
  BudgetValidationContext,
  BudgetValidationControlArea,
  BudgetValidationIssueRow,
  BudgetValidationWorkbenchModel,
} from './budgetvalidation.models';

const n=(value:any,fallback=0)=>Number.isFinite(Number(value))?Number(value):fallback;
const s=(value:any,fallback='')=>value==null?fallback:String(value);
const b=(value:any)=>value===true||value===1||value==='1'||String(value).toLowerCase()==='true';
const array=(value:any)=>Array.isArray(value)?value:[];

export const normalizeBudgetValidationWorkbench=(raw:any):BudgetValidationWorkbenchModel=>{
  const source=raw?.sd??raw??{};
  const contextRaw=source.context??{};
  const cardsRaw=source.cards??{};

  const context:BudgetValidationContext={
    planningcycleid:n(contextRaw.planningcycleid??contextRaw.pci),
    planningcyclecode:s(contextRaw.planningcyclecode??contextRaw.pcc),
    planningcyclename:s(contextRaw.planningcyclename??contextRaw.pcn),
    budgetperiodid:n(contextRaw.budgetperiodid??contextRaw.bpi),
    budgetperiodcode:s(contextRaw.budgetperiodcode??contextRaw.bpc),
    budgetperiodname:s(contextRaw.budgetperiodname??contextRaw.bpn),
    phasecode:s(contextRaw.phasecode,'BUDGET VALIDATION'),
    consolidationstatecode:s(contextRaw.consolidationstatecode??contextRaw.csc),
    consolidationstatename:s(contextRaw.consolidationstatename??contextRaw.csn),
    consolidationcomplete:b(contextRaw.consolidationcomplete),
    mode:s(contextRaw.mode,b(contextRaw.consolidationcomplete)?'ACTIVE':'PREVIEW'),
    stamp:s(contextRaw.stamp??contextRaw.stp),
  };

  const cards:BudgetValidationCards={
    requestedamount:n(cardsRaw.requestedamount),
    consolidatedamount:n(cardsRaw.consolidatedamount),
    arbitratedamount:n(cardsRaw.arbitratedamount),
    approvedcapacity:n(cardsRaw.approvedcapacity),
    remainingcapacity:n(cardsRaw.remainingcapacity),
    varianceamount:n(cardsRaw.varianceamount),
    utilisationpercent:n(cardsRaw.utilisationpercent),
    pendingarbitrations:n(cardsRaw.pendingarbitrations),
    blockingissues:n(cardsRaw.blockingissues),
    warningissues:n(cardsRaw.warningissues),
  };

  const controlareas:BudgetValidationControlArea[]=array(source.controlareas).map((row:any,index:number)=>({
    id:row.id??row.controlareaid??row.controlareacode??index,
    controlareacode:s(row.controlareacode),
    controlareaname:s(row.controlareaname),
    requestedamount:n(row.requestedamount),
    consolidatedamount:n(row.consolidatedamount),
    arbitratedamount:n(row.arbitratedamount),
    ceilingamount:n(row.ceilingamount),
    availableamount:n(row.availableamount),
    varianceamount:n(row.varianceamount),
    utilisationpercent:n(row.utilisationpercent),
    warningpercent:n(row.warningpercent),
    controlstatus:s(row.controlstatus),
  }));

  const arbitrations:BudgetValidationArbitrationRow[]=array(source.arbitrations).map((row:any,index:number)=>({
    id:row.id??row.arbitrationid??index,
    arbitrationid:n(row.arbitrationid),
    sourceclasscode:s(row.sourceclasscode),
    sourcecode:s(row.sourcecode),
    sourcename:s(row.sourcename),
    costcentercode:s(row.costcentercode),
    costcentername:s(row.costcentername),
    accountcode:s(row.accountcode),
    accountname:s(row.accountname),
    requestedamount:n(row.requestedamount),
    recommendedamount:n(row.recommendedamount),
    arbitratedamount:n(row.arbitratedamount),
    adjustmentamount:n(row.adjustmentamount,row.arbitratedamount-row.requestedamount),
    decisioncode:s(row.decisioncode),
    reason:s(row.reason),
    remarks:s(row.remarks),
    arbitratorname:s(row.arbitratorname),
    arbitratedat:s(row.arbitratedat),
    stamp:s(row.stamp??row.stp),
  }));

  const issues:BudgetValidationIssueRow[]=array(source.issues).map((row:any,index:number)=>({
    id:row.id??row.issueid??index,
    issueid:n(row.issueid),
    issuecode:s(row.issuecode),
    issueclasscode:s(row.issueclasscode),
    severitycode:s(row.severitycode),
    title:s(row.title),
    description:s(row.description),
    sourceclasscode:s(row.sourceclasscode),
    sourceid:n(row.sourceid),
    amount:n(row.amount),
    targetphasecode:s(row.targetphasecode),
    targetlabel:s(row.targetlabel),
    blocking:b(row.blocking),
    resolved:b(row.resolved),
  }));

  const actionsRaw=source.actions??{};
  const active=context.mode==='ACTIVE'&&context.consolidationcomplete;
  const actions:BudgetValidationActions={
    canRefresh:b(actionsRaw.canRefresh??true),
    canApprove:active&&b(actionsRaw.canApprove),
    canReturn:active&&b(actionsRaw.canReturn),
    canReject:active&&b(actionsRaw.canReject),
    canExit:b(actionsRaw.canExit),
    nextpage:actionsRaw.nextpage??null,
  };

  return {context,cards,controlareas,arbitrations,issues,actions};
};
